import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    '& .MuiPaper-root': {
      width: 440,
      // height: 200,
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: 4,
    },
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  body: {
    color: '#999',
  },
  body2: {
    marginTop: '10px',
  },
  actions: {
    padding: 20,
    display: 'flex',
    justifyContent: 'space-between',
  },
});
